import { Typography } from "@/components/custom/typography";
import { Card } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { CommonCDType } from "@/types/common-cd";
import { useEffect } from "react";

interface SearchAdOptionsProps {
  options: CommonCDType[];
  value: string[];
  onChange: (value: CommonCDType[]) => void;
  className?: string;
}

export function SearchAdOptions({
  options,
  value,
  onChange,
  className,
}: SearchAdOptionsProps) {
  const normalAd = options.find((opt) => opt.grp_sub_cd === "normal_ad");
  const otherOptions = options.filter((opt) => opt.grp_sub_cd !== "normal_ad");

  const handleSelect = (code: string, checked: boolean) => {
    let newCodes: string[];
    if (checked) {
      newCodes = [...value, code];
    } else {
      newCodes = value.filter((c) => c !== code);
    }

    const selectedOptions = otherOptions.filter((opt) =>
      newCodes.includes(opt.grp_sub_cd),
    );

    if (normalAd) {
      onChange([normalAd, ...selectedOptions]);
    } else {
      onChange(selectedOptions);
    }
  };

  useEffect(() => {
    if (normalAd && value.length === 0) {
      onChange([normalAd]);
    }
  }, [normalAd, value, onChange]);

  return (
    <div className={cn("space-y-3 group", className)}>
      {normalAd && (
        <Card className="w-full justify-center p-3">
          <Label className="flex-1 mb-0 flex gap-1 items-center">
            <Checkbox checked disabled />
            <Typography
              variant="subheading3"
              tone="darknormal"
              className="font-semibold"
            >
              {normalAd.common_cd_name}
            </Typography>
            <Typography as="span" className="text-xs text-gray-500 pl-1">
              {normalAd.notes}
            </Typography>
          </Label>
        </Card>
      )}

      {otherOptions.map((item) => (
        <Card
          key={item.grp_sub_cd}
          className="w-full justify-center py-3 cursor-pointer"
        >
          <Label className="flex-1 mb-0 flex gap-1 items-center cursor-pointer">
            <Checkbox
              checked={value.includes(item.grp_sub_cd)}
              onCheckedChange={(checked) =>
                handleSelect(item.grp_sub_cd, Boolean(checked))
              }
            />
            <Typography
              as="span"
              tone="darknormal"
              className="text-sm font-semibold"
            >
              {item.common_cd_name}
            </Typography>
            <Typography
              as="span"
              tone="darknormal"
              className="text-xs text-gray-500 pl-1"
            >
              {item.notes}
            </Typography>
          </Label>
        </Card>
      ))}
    </div>
  );
}
